import "../OneWord/oneWord.css";
import "../TestQuestions/Question.css";
import { useEffect, useMemo, useState } from "react";
import EditCard from "../../EditCard/EditCard";
import QuestionChecker from "../TestQuestions/QuestionChecker";
import { QuestionImg, QuestionMedia } from "../TestQuestions/Component";
import CognitiveIcon from "../TestQuestions/Component/CognitivieIcon";
import { htmlDecode } from "../../../utils/parse";
import { Checkbox } from "@material-ui/core";

export default function Descriptive({
  isPraticeSession,
  isChecked,
  question,
  index,
  deleteQuestion,
  setQuestId,
  setSelQuest,
  reviewQuestion,
  page,
  getTotalMarks,
  setReviewQuestion,
  setChecked,
  setChaptersState,
  chaptersState,
  setTopicsState,
  setCheckMarksState,
  topicsState,
}) {
  const [edit, setEdit] = useState(false);
  const openEdit = () => setEdit(true);
  const closeEdit = () => setEdit(false);

  const input = useMemo(() => {
    const blanks = (question.correctAnswers?.descriptive || []);
    return blanks[0] || { blankId: "op1", answer:"" };
  },[question.correctAnswers]);

  useEffect(() => {
    if (window.MathJax) window.MathJax.typesetPromise();
  }, [question.question]);

  return (
    <>
      {edit && (
        <EditCard
          edit={edit}
          closeEdit={closeEdit}
          quesType="oneword"
          question={question}
          setQuestId={setQuestId}
          setSelQuest={setSelQuest}
          isMarks={false}
          assessmentType="competency"
        />
      )}
      <div
        className={
          isChecked
            ? "my-4 question-c onlineQuestionCard"
            : "my-4 question-c questionCard"
        }
        style={{ display: edit ? "none" : "block" }}
      >
        <div className="superhead">
          <div
            className={
              isPraticeSession ? "remark ps_remark" : "remark ot_remark"
            }
          >
            HOTS Question
          </div>
          <div
            className={
              isPraticeSession
                ? "one__head ps_mcq_head"
                : "one__head ot_mcq_head"
            }
          >
            <QuestionChecker
              isStaff={question.onModel === "staff"}
              type={question.questionType}
              options={question.options}
              correctAnswers={question.correctAnswers[question.questionType]}
              answers={input}
              editMode={edit}
              openEdit={openEdit}
              delete={() => deleteQuestion(question._id)}
              isPraticeSession={isPraticeSession}
              staff={{
                name: question.creatorId?.name,
                schoolName: question.schoolId?.name,
              }}
            >
              <div className="oneCard">
                <div
                  className="oneCard__left"
                  style={
                    isPraticeSession
                      ? { marginTop: "16px" }
                      : { marginTop: "", display: "flex", alignItems: "center" }
                  }
                >
                  <div style={{ minWidth: "fit-content" }}>
                    Q{5 * (page - 1) + index}.&nbsp;
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: htmlDecode(question.question),
                    }}
                  ></div>
                </div>
                {question.cognitive?<div className="oneCard__right">
                <span
                  className={
                    isPraticeSession
                      ? "difficulty_status bg_ps"
                      : "difficulty_status bg_ot"
                  }
                >
                  <CognitiveIcon/>
                  {question.cognitive}
                </span>
                </div>:null}
                {isChecked ? (
                  <Checkbox
                    style={{ marginLeft: "auto" }}
                    className={isChecked ? "checkbox ot" : "checkbox ps"}
                    checked={
                      reviewQuestion.findIndex((x) => x._id === question._id) >
                      -1
                        ? true
                        : false
                    }
                    onClick={(e) => {
                      if (e.target.checked) {
                        chaptersState.push(question.chapterId);
                        setChaptersState(chaptersState);
                        topicsState.push(question.topicId);
                        setTopicsState(topicsState);
                        //    getTotalMarks(0)
                        setChecked(true);
                        setReviewQuestion((arr) => [...arr, { ...question }]);
                        getTotalMarks(question.marks || 0);
                      } else {
                        // getTotalMarks(0)
                        setCheckMarksState(true);
                        setChecked(false);
                        const index = reviewQuestion.findIndex(
                          (x) => x._id === question._id
                        );
                        getTotalMarks(-reviewQuestion[index]?.["marks"]);
                        reviewQuestion.splice(index, 1);
                        setReviewQuestion(reviewQuestion);

                        const i = chaptersState.findIndex(
                          (x) => x === question.chapterId
                        );
                        chaptersState.splice(i, 1);
                        setChaptersState(chaptersState);

                        const j = topicsState.findIndex(
                          (x) => x === question.chapterId
                        );
                        topicsState.splice(j, 1);
                        setTopicsState(topicsState);
                      }
                    }}
                  />
                ) : (
                  ""
                )}
              </div>

              <div
                className="question-body"
                style={
                  question.images?.questionImg
                    ? { justifyContent: "start" }
                    : { justifyContent: "unset" }
                }
              >
                {question.images?.questionImg ? (
                  <QuestionMedia url={question.images?.questionImg} />
                ) : null}
                <textarea
                  className={isPraticeSession ? "ps-op1" : "ot-op1"}
                  style={{ marginRight: "20px" }}
                  name={"op1"}
                  value={input.answer}
                  readOnly={!isPraticeSession}
                />
              </div>
            </QuestionChecker>
          </div>
        </div>
      </div>
    </>
  );
}
